import { z } from 'zod';

// AIDEV-SECURITY: PushPayload nao inclui PII — apenas IDs e mensagens genericas.
// AIDEV-NOTE: Tipos compartilhados entre server (envio) e client (recebimento)

export const NotificationTriggerTypeSchema = z.enum([
  'sync_error',
  'crm_stale',
  'team_performance'
]);
export type NotificationTriggerType = z.infer<typeof NotificationTriggerTypeSchema>;

export const PushPayloadSchema = z.object({
  title: z.string().min(1),
  body: z.string().min(1),
  url: z.string().startsWith('/'),
  triggerType: NotificationTriggerTypeSchema
});
export type PushPayload = z.infer<typeof PushPayloadSchema>;

export const PushSubscriptionInputSchema = z.object({
  endpoint: z.string().url('Endpoint deve ser uma URL valida'),
  keys: z.object({
    p256dh: z.string().min(1, 'p256dh e obrigatorio'),
    auth: z.string().min(1, 'auth e obrigatorio')
  })
});
export type PushSubscriptionInput = z.infer<typeof PushSubscriptionInputSchema>;
